import type { Plan } from '../services/stripeApi';

/**
 * Aviso de asientos antes de pagar: la prueba da 3 usuarios por sucursal y Básico
 * incluye 1. Contratar no desactiva a nadie (el límite solo frena altas nuevas), pero
 * el dueño tiene que saberlo antes de elegir, no descubrirlo después.
 *
 * Al contratar, el límite queda en el mayor entre lo que da el plan y lo que soporte ya
 * le había otorgado (`granted`): sin contarlo, el aviso empujaba a un plan más caro a
 * quien ya tenía los asientos.
 */
export function seatNotice(plan: Plan, currentUsers: number, granted: number, plans: Plan[]): string | null {
  const seatsAfter = (p: Plan) => Math.max(p.maxUsers, granted);
  if (currentUsers <= seatsAfter(plan)) return null;
  const fits = [...plans]
    .sort((a, b) => a.maxUsers - b.maxUsers)
    .find((p) => seatsAfter(p) >= currentUsers);
  const base = `Tienes ${currentUsers} usuarios y este plan incluye ${seatsAfter(plan)}. `
    + 'Tus usuarios actuales siguen entrando, pero no podrás dar de alta más.';
  return fits
    ? `${base} ${fits.displayName} incluye ${seatsAfter(fits)}.`
    : `${base} Escríbenos si necesitas más usuarios.`;
}
